import { render, staticRenderFns } from "./bike-coupons.vue?vue&type=template&id=1c5ce3b6&scoped=true&lang=pug&"
import script from "./bike-coupons.vue?vue&type=script&lang=js&"
export * from "./bike-coupons.vue?vue&type=script&lang=js&"
import style0 from "./bike-coupons.vue?vue&type=style&index=0&id=1c5ce3b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5ce3b6",
  null
  
)

export default component.exports